import * as factories from './factories';

export const AlertModel = {
  ...factories,
};
